/** Search/group data already present in the streamed nationwide worklist.
 * No extra SQL, no per-row API calls. The source registration is never changed. */
export const normalizeOperator = (value) => String(value ?? '')
  .toLocaleLowerCase('pl-PL').replace(/ł/g, 'l').normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');

const digits = (value) => String(value ?? '').replace(/\D/g, '');
export function operatorKey(row) {
  const nip = digits(row?.operator_nip);
  if (nip.length === 10 && !/^0+$/.test(nip)) return 'nip:' + nip;
  const regon = digits(row?.operator_regon);
  if ((regon.length === 9 || regon.length === 14) && !/^0+$/.test(regon)) return 'regon:' + regon;
  const name = normalizeOperator(row?.operator_name);
  return name.length >= 5 ? 'name:' + name : '';
}
export function matchesOperatorKey(row, key) {
  if (!key) return true;
  if (key.startsWith('nip:')) return digits(row?.operator_nip) === key.slice(4);
  if (key.startsWith('regon:')) return digits(row?.operator_regon) === key.slice(6);
  if (key.startsWith('name:')) return normalizeOperator(row?.operator_name) === key.slice(5);
  return false;
}
export function matchesMarketSearch(row, query) {
  const needle = normalizeOperator(query);
  if (!needle) return true;
  const numberQuery = digits(query);
  if (numberQuery.length >= 4 && (digits(row.operator_nip).includes(numberQuery) || digits(row.operator_regon).includes(numberQuery))) return true;
  return normalizeOperator([
    row.name, row.operator_name, row.operator_nip, row.operator_regon,
    row.registry_source, row.registry_id, row.commune, row.county,
    row.region, row.area_id, row.id,
  ].join(' ')).includes(needle);
}
/** Offer a few operator groups, not 100k autocomplete results. */
export function operatorSuggestions(items, query, max = 5) {
  const needle = normalizeOperator(query);
  const numberQuery = digits(query);
  if (needle.length < 3 && numberQuery.length < 4) return [];
  const groups = new Map();
  for (const row of items) {
    const label = String(row.operator_name || '').trim();
    const nip = digits(row.operator_nip), regon = digits(row.operator_regon);
    if (!label || !(
      normalizeOperator(label).includes(needle) ||
      (numberQuery.length >= 4 && (nip.includes(numberQuery) || regon.includes(numberQuery)))
    )) continue;
    const key = operatorKey(row);
    if (!key) continue;
    const previous = groups.get(key);
    if (previous) previous.count += 1;
    else groups.set(key, { key, label, count: 1, nip: nip.length === 10 ? nip : '' });
  }
  return [...groups.values()].sort((a, b) => b.count - a.count || a.label.localeCompare(b.label, 'pl')).slice(0, max);
}
